module.exports = __webpack_public_path__ + "e5bbafd257338a364f3e2be759bff1ac.png";